/**
 * Checks if any properties inside object are true
 * @param {Object} object The object to check with properties to check if true
 * @returns Boolean value based on if any property in object has true value
 */
export const checkSomeObjectPropertiesTrue = (object) => {
  return Object.values(object).some((property) => {
    return property === true;
  });
};
